import React from 'react';

interface ErrorHandlerProps extends React.PropsWithChildren {
  visible: boolean;
  message: string;
}

export default function ErrorHandler({ visible, message, children }: ErrorHandlerProps) {
  if (!visible) {
    return children;
  }

  return (
    <div className="error-wrapper">
      <div className="error-card">
        <div className="error-title">🚨 Error</div>
        <div className="error-message">
          {message}
        </div>
      </div>
    </div>
  );
}
